import { render, staticRenderFns } from "./RealTimeVpdHdComponent.vue?vue&type=template&id=0d17b7ed&"
import script from "./RealTimeVpdHdComponent.vue?vue&type=script&lang=js&"
export * from "./RealTimeVpdHdComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports